import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const GeneralSettingsService = {
  getList: async () => {
    const response = await apiService.get(
      `/${slug}/configuration/general-setting`
    );
    return response.data;
  },
  update: async (data) => {
    const response = await apiService.put(`/${slug}/configuration`, data);
    return response.data;
  },
};

export default GeneralSettingsService;
